import React, { useState } from 'react';
import dayjs from 'dayjs';
import { StaticTimePicker } from '@mui/x-date-pickers';
import { useTranslation } from 'react-i18next';

import { useComposer, useDelivery } from '../../../../../hooks/index';
import { DateProvider } from '../../../../../Providers/index';
import { DateWrapper } from '../../../../../Components/index';
import {
  Container,
  LeftSection,
  ComposerButton,
  Airplane,
  Input,
  Label,
  labelAnimations
} from '../Custom/MessageComposer';

const isValid = date => dayjs(date, 'HH:mm').isValid();

const TimeComposer = () => {
  const [open, setOpen] = useState(false);

  const { t } = useTranslation('full_page');

  const { reply, setReply } = useComposer();

  const { sendMessage } = useDelivery();

  const handleChange = date => {
    setReply(dayjs(date).format('HH:mm'));
  };

  const handleInputClick = () => setOpen(open => !open);

  const handleSend = () => {
    if (isValid(reply)) {
      sendMessage(reply);
      setOpen(false);
      setReply('');
    }
  };

  return (
    <DateProvider primary="#FFFFFF">
      <DateWrapper>
        {open && (
          <StaticTimePicker
            open
            variant="dialog"
            TextFieldComponent={() => null}
            localeText={{ timePickerToolbarTitle: '' }}
            margin="dense"
            minutesStep={5}
            onAccept={date => {
              handleChange(date);
              setOpen(false);
            }}
            onChange={handleChange}
            slotProps={{
              actionBar: {
                actions: [],
              },
            }}
            value={
              reply
                ? dayjs(reply, 'HH:mm')
                : null
            }
            maxDate={dayjs().add('10', 'year')}
          />
        )}
        <Container>
          <LeftSection htmlFor="time-composer">
            <Label
              htmlFor="time-composer"
              initial="expanded"
              variants={labelAnimations}
              animate={open || reply ? 'minimised' : 'expanded'}>
              {t('time_composer_label')}
            </Label>
            <Input
              id="time-composer"
              readOnly
              value={reply}
              onClick={handleInputClick}
            />
          </LeftSection>
          <ComposerButton
            aria-label={t('send_button_label')}
            onClick={handleSend}>
            <Airplane />
          </ComposerButton>
        </Container>
      </DateWrapper>
    </DateProvider>
  );
};

export default TimeComposer;
